<div *ngIf="field.frontendLabel!='Custom Product Resource' && field.frontendLabel!='Course Includes' && field.frontendLabel!='Amenities'">
  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
    <mat-select [attr.guide]="'multi-select-sel-1' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
     [disableOptionCentering]="true"  [multiple]="true"
      [formControlName]="field.attributeCode" #multiSelect>
      <mat-option>
        <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="fieldFilterControl"
          placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option   *ngFor="let item of fieldTypeList" [value]="item.optionId">
        {{item.eavAttributeOptionValue[0]?.value}}</mat-option>
        
    </mat-select>
    <div  *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
    </div>
  </mat-form-field>
</div>

<div *ngIf="field.frontendLabel=='Custom Product Resource'">

  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
  <ng-container >
    <mat-select [attr.guide]="'multi-select-sel-2' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
    [multiple]="true"
     [disableOptionCentering]="true" #multiSelect
      [formControlName]="field.attributeCode">
      <mat-option>
        <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="customResourceFilterControl"
          placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let opt of filteredCustomResourceTypeList" [value]="opt.valueId">
        {{opt.value}}
      </mat-option>
    </mat-select>
  </ng-container>
  </mat-form-field>

 </div>


 <div *ngIf="field.frontendLabel=='Course Includes'">

  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
  <ng-container >
    <mat-select [attr.guide]="'multi-select-sel-3' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
    [multiple]="true"
     [disableOptionCentering]="true" #multiSelect
      [formControlName]="field.attributeCode">
      <mat-option>
        <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="customResourceFilterControl"
          placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let opt of filteredCustomResourceTypeList" [value]="opt.specificationId">
        {{opt.name}}
      </mat-option>
    </mat-select>
  </ng-container>
  </mat-form-field>

 </div>

 <div *ngIf="field.frontendLabel=='Amenities'">

  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
  <ng-container >
    <mat-select [attr.guide]="'multi-select-sel-4' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
    [multiple]="true"
     [disableOptionCentering]="true" #multiSelect
      [formControlName]="field.attributeCode">
      <mat-option>
        <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="customResourceFilterControl"
          placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let opt of filteredCustomResourceTypeList" [value]="opt.specificationId">
        {{opt.name}}
      </mat-option>
    </mat-select>
  </ng-container>
  </mat-form-field>

 </div>




